import './../Status.scss';
import React from 'react';
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from '../../../../redux/hooks';
import { useDispatch } from 'react-redux';
import Plot from "react-plotly.js";
import { DataName, SensorNodeStatus } from '../../../../util/model';

interface Props {
    index: number;
}

export default function ElementPower(props: Props) {
    const colorGray = 'rgba(140,140,140,1)';
    const colorWhite = 'rgba(255,255,255,1)';
    const colorYellow = 'rgba(255,255,140,1)';
    const colorRed = 'rgba(255,140,140,1)';
    var layout_elementpower = {
        height: 300,
        title: {
            text: 'Element Relative Power',
            font: {
                color: 'white',
                size: 12
            }
        },
        margin: {
            l: 50,
            r: 30,
            b: 50,
            t: 30,
            pad: 0
        },
        showlegend: true,
        legend: {
            font: {color: 'white'}
        },
        xaxis: {
            title: {
                text: '',
                font: {
                    color: 'white'
                }
            },
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        yaxis : {
            title: {       
                font: {
                    color: 'white'
                }
            },        
            autorange: true,
            tickcolor: 'white',
            tickfont: {
                color: 'white'
            },
            gridcolor: "rgb(110, 110, 50)",
            mirror: true,
            linewidth: 1,
            linecolor: "rgb(255, 255, 140)"
        },
        plot_bgcolor :"black",
        paper_bgcolor:"black"
    };
    const [layout_power, setPowerLayout] = useState(layout_elementpower);
    var power = [{
        x: ['1','2','3','4','5','6','7','8'],
        y: [0,0,0,0,0,0,0,0],
        type: 'bar',
        name: 'L1',
        marker: {color: colorWhite}
    },{
        x: ['1','2','3','4','5','6','7','8'],
        y: [0,0,0,0,0,0,0,0],
        type: 'bar',
        name: 'L2',
        marker: {color: colorYellow}
    }];
    const [data_power, setPowerData] = useState(power);

    const dispatch = useDispatch();
    const layerData = useAppSelector(state => state.layerData);
    
    const SNTime = layerData.status.Time;
    const SNStatus = layerData.status.SensorNodeStatus;
    
    useEffect(() => {
        if((props.index >= 0) && (props.index < SNStatus.length)) {
            var localTime = new Date(SNStatus[props.index].ElementPower.Time);
            var power = [{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L1',
                marker: {color: colorWhite}
            },{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L2',
                marker: {color: colorYellow}
            }];
            if(SNStatus[props.index].ElementPower.Array.length > 0) {
                power[0].y = SNStatus[props.index].ElementPower.Array[0].Power;
            }
            if(SNStatus[props.index].ElementPower.Array.length > 1) {
                power[1].y = SNStatus[props.index].ElementPower.Array[1].Power;
            }
            setPowerData(power);
            var powerLayout = layout_power;
            powerLayout.title.text = SNStatus[props.index].Name + ' Element Relative Power ' + localTime.toLocaleString();
            setPowerLayout(powerLayout);
        } else {
            var power = [{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L1',
                marker: {color: colorWhite}
            },{
                x: ['1','2','3','4','5','6','7','8'],
                y: [0,0,0,0,0,0,0,0],
                type: 'bar',
                name: 'L2',
                marker: {color: colorYellow}
            }];
            setPowerData(power);  
            var powerLayout = layout_power;
            powerLayout.title.text = 'Element Relative Power';
            setPowerLayout(powerLayout);
        } 
    }, [SNTime, props.index]);
    
    return (
        <div className='element_power_div'>
            <Plot data={data_power as any} layout={layout_power} useResizeHandler={true} style={{ width: '100%', height: '100%' }}/>
        </div>
    )
}
